export default __webpack_public_path__ + "dissolver.png?423eb680bcda8d3287d44216c1a314f9";